import { CardContent, Divider, IconButton, TextField, Typography } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";

interface Props {
  newInventory?: string;
  setNewInventory: (item: string) => void;
}

export function InventoryCreate({ newInventory, setNewInventory }: Readonly<Props>) {
  const { t } = useTranslation();

  return (
    <>
      <Divider sx={{ opacity: "0.6" }} />
      <Typography mt={2} align={"center"}>
        {t("CreateNewInventoryLabel")}
      </Typography>
      <CardContent>
        <TextField
          data-testid="create-new-inven"
          value={newInventory}
          fullWidth
          label={t("NewInventoryNameLabel")}
          onChange={event => {
            setNewInventory(event.target.value);
          }}
          slotProps={{
            input: {
              endAdornment: (
                <>
                  {newInventory && (
                    <IconButton
                      data-testid="clear-inven"
                      onClick={() => setNewInventory("")}
                      size="large"
                    >
                      <ClearIcon />
                    </IconButton>
                  )}
                </>
              )
            }
          }}
        />
      </CardContent>
    </>
  );
}
